export default "__VITE_ASSET__Bh9r3Pus__"